import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "@/components/AdminLayout";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { Briefcase, Users, Trophy, Clock, Award, TrendingUp, ArrowRight } from "lucide-react";

const Kpi = ({ icon: I, label, value, testid }) => (
  <Card className="bg-slate-900 border-slate-800 p-5 text-white" data-testid={testid}>
    <div className="flex items-center justify-between">
      <I className="w-5 h-5 text-[#F59E0B]"/>
      <TrendingUp className="w-3.5 h-3.5 text-slate-600"/>
    </div>
    <div className="mt-6 font-display text-3xl font-bold">{value ?? 0}</div>
    <div className="text-xs uppercase tracking-wider text-slate-400 mt-1">{label}</div>
  </Card>
);

export default function RecruiterDashboard() {
  const [d, setD] = useState(null);
  useEffect(()=>{ api.get("/recruiter/dashboard").then(r=>setD(r.data)); },[]);
  if (!d) return <AdminLayout><div className="text-slate-400">Loading...</div></AdminLayout>;
  return (
    <AdminLayout>
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.2em] text-[#F59E0B]">Recruiter</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-white mt-1">My Workspace</h1>
        <p className="text-slate-400 mt-1">Jobs assigned to you, candidates in your pipeline and their status.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
        <Kpi icon={Briefcase} label="My Jobs" value={d.kpis.jobs} testid="rec-kpi-jobs"/>
        <Kpi icon={Users} label="Applications" value={d.kpis.applications} testid="rec-kpi-apps"/>
        <Kpi icon={Trophy} label="Shortlisted" value={d.kpis.shortlisted} testid="rec-kpi-shortlisted"/>
        <Kpi icon={Clock} label="Interviews" value={d.kpis.interviews} testid="rec-kpi-interviews"/>
        <Kpi icon={Award} label="Offers" value={d.kpis.offers} testid="rec-kpi-offers"/>
        <Kpi icon={Award} label="Selected" value={d.kpis.selected} testid="rec-kpi-selected"/>
      </div>
      <Card className="bg-slate-900 border-slate-800 p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-display text-lg font-semibold text-white">My Jobs</h2>
          <Link to="/recruiter/applications" className="text-sm text-[#F59E0B] flex items-center gap-1 hover:underline">View applications <ArrowRight className="w-3 h-3"/></Link>
        </div>
        {d.my_jobs.length === 0 ? (
          <p className="text-sm text-slate-500 py-8 text-center">No jobs assigned to you yet. Ask a super admin to assign jobs.</p>
        ) : (
          <div className="space-y-2">
            {d.my_jobs.map(j => (
              <div key={j.id} className="border border-slate-800 rounded-md p-4 flex justify-between items-center flex-wrap gap-3">
                <div>
                  <div className="font-semibold text-white">{j.title}</div>
                  <div className="text-xs text-slate-400 mt-0.5">{j.location} · {j.domain || j.department} · {j.experience_category || `${j.experience_min}-${j.experience_max} yrs`}</div>
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {(j.required_skills||[]).slice(0,3).map(s => <Badge key={s} className="bg-slate-700 text-white border-none hover:bg-slate-700 text-[10px]">{s}</Badge>)}
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </AdminLayout>
  );
}
